export default __webpack_public_path__ + "static/media/sentierBackground.e926a0d6.jpg";